import { useState } from "react";


interface JobsCountApiResponseData { [key: string]: { total: number, new: number, closed: number } }
interface JobsCountApiResponse {
    success: boolean,
    data: JobsCountApiResponseData | null
}

async function _delay(ms: number) {
    await new Promise(resolve => setTimeout(resolve, ms));
}

export default function useJobsCountAPI() {

    const [dataLoaded, setDataLoaded] = useState(false)
    const [loading, setLoading] = useState(false)
    const [counters, setCounters] = useState<JobsCountApiResponseData | null>(null)

    async function fetchJobsCount(region?: string) {
        // await _delay(2000)
        setLoading(true)
        setDataLoaded(false)

        const api_url = process.env.REACT_APP_API_SERVER_URL
        const api_version = process.env.REACT_APP_API_VERSION
        const res = await fetch(`${api_url}/api/${api_version}/jobs/count${Boolean(region) ? `?region=${region}` : ''}`,
            {
                credentials: 'include',
                cache: 'no-store',
            }
        )

        const apiResponse: JobsCountApiResponse = await res.json()
        const batchSummary = apiResponse.data

        setLoading(false)
        setCounters(batchSummary)
        setDataLoaded(batchSummary != null)

    }

    return { loading, counters, fetchJobsCount, dataLoaded }
}